import { EcosystemServiceModel } from "@shared/models/ecosystem-service.model";

export const _09_WATER_AS_ENERGY:Partial<EcosystemServiceModel> ={
  id:'water-as-energy',
  pos:9,
  image: "/images/ecoservices/water_as_energy.jpg",
  code: ["4.2.1.3"],
  unit:'water as energy',
  assetType:'other',
  serviceType: 'provisioning',
  valuationMethods:[
    {
      id: 'market',
      name:"Market prices",
      unit: "kwh",
      element: "water as energy",
      altUnits: null,
      qtyIndices: [
        { id: "quality", name: "Quality Index", included: true },
      ],
      valueIndices: []
    }
  ]

}
